import React, { useEffect } from 'react';
import * as dateFns from 'date-fns';

import { NUMBER_OF_WEEK_DAYS } from '../../../../config/constants';
import DayHeader from './DayHeader/DayHeader';
import { isCC, isNCAAAllSports, isTA, routeToDate } from '../../../../helpers';
import { useUserState } from '../../../../store/hooks';
import { useRouter } from '../../../../helpers/customHooks';
import { RenderDaysPropsType } from './types';

const RenderDays = ({ indexAddButton }: RenderDaysPropsType) => {
  
  const user = useUserState();
  // const weather = useWeatherState();
  const { pathname } = useRouter();
  const pathOnlyDate = pathname.split('/').slice(0, 6).join('/');
  
  const selectedWeek = routeToDate(pathOnlyDate);
  // useEffect(() => {
  //   loadWeekWeather(selectedWeek);
  // }, [pathOnlyDate]);
  const days = [];
  let currentDate = dateFns.startOfWeek(selectedWeek);
  for (let i = 0; i < NUMBER_OF_WEEK_DAYS; i++) {
    days.push(
      <DayHeader
        key={i}
        numDay={i}
        date={currentDate}
        // dailyWeather={weather[dateFns.startOfDay(currentDate)]}
        showAddButton={indexAddButton === i && (isCC(user) || isTA(user) || isNCAAAllSports(user))}
      />
    );
    currentDate = dateFns.addDays(currentDate, 1);
  }
  return (
    <>
      <div className="days row" id={'Week-days'}>
        {days}
      </div>
    </>
  );
};

export default RenderDays;
